module.exports = __webpack_public_path__ + "assets/arrow.78ea820a.svg";